import {Component, OnInit, ViewChild} from '@angular/core';
import {RolesMgmtService} from '../@shared/new-services/roles-mgmt.service';
import {MenuItem, MessageService} from 'primeng/api';
import {Platform} from '@angular/cdk/platform';
import {Paginator} from 'primeng/paginator';
import {Menu} from 'primeng/menu';
import {Router} from '@angular/router';
import {CacheService} from '../@shared/services/cache.service';

@Component({
    selector: 'app-roles-mgmt',
    templateUrl: './roles-mgmt.component.html',
    styleUrls: ['./roles-mgmt.component.scss']
})
export class RolesMgmtComponent implements OnInit {

    paginatedRoles: any;
    isLoading: boolean;
    breadcrumbMenuModel: MenuItem[] = [];
    home: MenuItem = {icon: 'pi pi-home', routerLink: '/booking-summary'};

    @ViewChild('rolePagination') rolePagination: Paginator;
    roleOptionMenu: MenuItem[] = [];
    @ViewChild('rolesMenu') rolesMenu: Menu;
    selectedRole: any;
    loggedInUser = this.cacheService.retrieveParsedResponse('detailedLoggedInUser');


    constructor(private rolesMgmtService: RolesMgmtService,
                private messageService: MessageService,
                public platform: Platform,
                private router: Router,
                private cacheService: CacheService) {
    }

    ngOnInit(): void {
        this.breadcrumbMenuModel = [
            {label: 'Roles Management'},
        ];
        this.getPaginatedRoles();
    }

    getPaginatedRoles(page = 0, size = 10) {
        this.isLoading = true;
        this.rolesMgmtService
            .getPaginatesRoles(page, size)
            .subscribe((roles) => {
                this.paginatedRoles = roles;
                this.roleOptionMenu = [
                    {
                        label: this.loggedInUser?.editRoles ? 'Edit Access' : 'View Access',
                        command: () => {
                            this.navigateToEditRole(this.selectedRole);
                        },
                        // disabled: this.loggedInUser?.editRoles
                    },
                ];
                this.isLoading = false;
            }, (error) => {
                this.isLoading = false;
                this.presentToastMessage('error', error?.message ? error?.message : error);
            });
    }

    navigateToAddRole() {
        this.router
            .navigate(['/', 'manage-role'], {
                queryParams: {
                    mode: 'add'
                }
            });
    }

    navigateToEditRole(role: any) {
        this.router
            .navigate(['/', 'manage-role'], {
                queryParams: {
                    roleId: role?.roleId,
                    mode: 'edit'
                }
            });
    }

    paginateRoles(event: any) {
        this.getPaginatedRoles(event?.page, event?.rows);
    }

    handleRoleOptionMenu(event: Event, role) {
        this.rolesMenu.toggle(event);
        this.selectedRole = role;
    }


    presentToastMessage(severity, detail) {
        this.messageService
            .add(
                {
                    severity,
                    summary: 'Roles Management Message',
                    key: 'roles-mgmt-message',
                    detail,
                }
            );
    }

}
